import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import html2pdf from "html2pdf.js";
import { Box, Table, Typography } from '@mui/joy';
import BewertungsCard from '../../VergleichSubKathegorie/Tarif/TarifStandViewer/Tabs/BewertungsCard';

function BestTarifErgebniss() {
    const location = useLocation();
    const [selectede, setSelectede] = useState(null);
    const [subkathdata, setSubkathdata] = useState(null);
    const [n, setN] = useState(null);
    const [data, setData] = useState(null);
    const [fragenob, setFragen] = useState(null);
    const [hasDownloaded, setHasDownloaded] = useState(false);
    const [ftob, setFtob] = useState(null);
    const pdfRef = useRef();

    const handleDownload = () => {
        if (!data) return;
        const element = pdfRef.current;
        const opt = {
            margin: 0.3,
            filename: `${data.name || "download"}.pdf`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
            },
            jsPDF: {
                unit: 'in',
                format: 'a4',
                orientation: 'portrait'
            },
            pagebreak: { mode: ['css', 'legacy'] }
        };
        html2pdf().set(opt).from(element).save();
    };

    useEffect(() => {
        const key = "get_best_ergebniss_data";
        const raw = localStorage.getItem(key);

        if (raw) {
            try {
                const parsed = JSON.parse(raw);

                setData(JSON.parse(parsed.response) || null);
                setSelectede(parsed.selectede || null);
                setFragen(parsed.fragen || null);
                setSubkathdata(parsed.subkathdata || null);
                setN(parsed.n || null);

                setFtob(parsed.n || null); // falls ftob gleich n sein soll

                setHasDownloaded(false); // Download noch nicht gemacht
                console.log(parsed.response)
            } catch (e) {
                console.error("Fehler beim Parsen aus localStorage:", e);
            }
        }
    }, []);

    // Download starten, wenn selectede === "PDF" und noch nicht heruntergeladen
    useEffect(() => {
        if (selectede === "PDF" && !hasDownloaded) {
            setHasDownloaded(true);
            handleDownload();
        }
    }, [selectede, hasDownloaded]);

    if (!data) {
        return null; // oder <div>Lade Daten...</div>
    }

    return (
        <div
            ref={pdfRef}
            style={{
                width: '794px', // A4 Breite bei 96dpi
                margin: 'auto',
                padding: 20,
                backgroundColor: '#fff',
                color: '#000',
                fontFamily: 'Arial, sans-serif',
                boxSizing: 'border-box',
                boxShadow:
                    'rgba(0, 0, 0, 0.25) 0px 54px 55px, ' +
                    'rgba(0, 0, 0, 0.12) 0px -12px 30px, ' +
                    'rgba(0, 0, 0, 0.12) 0px 4px 6px, ' +
                    'rgba(0, 0, 0, 0.17) 0px 12px 13px, ' +
                    'rgba(0, 0, 0, 0.09) 0px -3px 5px',
                marginTop: 15,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Typography level="h2">{data.name}</Typography>
            <Typography>
                Bei einem Vergleich unter allen {subkathdata?.name} Tarifen schneidet {data.name} am besten ab
            </Typography>
            <Typography>Ihre Fragenauswahl wurde berücksichtigt</Typography>
            <Table
                stickyHeader
                borderAxis="both"
                sx={{
                    '& thead th:nth-child(1)': { width: '35%' },
                    '& thead th:nth-child(2)': { width: '10%' },
                    width: '100%',
                    bgcolor: "white",
                    '& td': {
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',

                    },
                }}
            >
                <thead>
                    <tr>
                        <th>Frage</th>
                        <th>Bewertung</th>
                        <th>Leistungsbeschreibung von {data.name}</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(fragenob) &&
                        fragenob
                            .slice()
                            .sort((a, b) => a.order - b.order)
                            .map((item, index) => {
                                const keys = Object.keys(item).filter((k) => k !== "order");
                                const name = keys[0] || "Unbenannt";
                                return (
                                    <React.Fragment key={`${index}-${name}`}>
                                        <tr>
                                            <td colSpan={1} style={{ fontWeight: 'bold' }}>
                                                {name}
                                            </td>
                                            <td />
                                            <td />
                                        </tr>
                                        {Array.isArray(item[name]) &&
                                            item[name]
                                                .slice()
                                                .filter((i) => ftob?.includes(i.name))
                                                .sort((a, b) => a.order - b.order)
                                                .map((frage, idx) => {
                                                    console.log("debug " + data)

                                                    return (<tr key={`${index}-${idx}`}>
                                                        <td>{frage.name}</td>
                                                        <td>
                                                            <BewertungsCard
                                                                id={data?.lasttarif?.bewertung?.find((a) => a.question === frage.name)}
                                                                item={frage}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Typography>
                                                                {data?.lasttarif?.questions?.find((a) => a.question === frage.name)?.antwort}
                                                            </Typography>
                                                        </td>
                                                    </tr>)
                                                })}
                                    </React.Fragment>
                                );
                            })}
                </tbody>
            </Table>
            <Box sx={{ width: '100%', mt: 3 }}>
                <Typography level="title-mg">Empfehlung</Typography>
                <Typography>{data?.lasttarif?.empfehlung}</Typography>
            </Box>
        </div>
    );
}

export default BestTarifErgebniss;
